import type { HandleDeepLinkArgs } from "@hopper-ai/hts-assist-components";

// The current HTS Assist deep-link schema only covers flight-exchange and
// premium-disruption-assistance flows, neither of which has a dedicated route
// wired up in RBC yet, so both are minimally routed to the trips list. A
// fuller per-type mapping (mirroring whopper's SupportModal) is follow-up
// work; anything outside the known union logs instead of navigating.
export const getHtsAssistDeepLinkPath = (
  args: HandleDeepLinkArgs
): string | undefined => {
  switch (args.type) {
    case "FlightExchange":
    case "PremiumDisruptionAssistance":
      return "/trips";
    default: {
      // Exhaustive: a new deep-link type surfaces here as a build error,
      // while at runtime we return undefined (no navigation) for safety.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const _exhaustive: never = args;
      return undefined;
    }
  }
};
